var $ = window.jQuery = require('jquery');
import {
  bus
} from '../../main';
export default {
  name: 'quiz-category',
  components: {},
  props: [],
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {
    this.randomImgLoaded()
  },
  methods: {
    randomImgLoaded() {
      // Multi Color Bg Img Of Section
      var images = ["random_img1", "random_img2", "random_img3", "random_img4", "random_img5", "random_img6", "random_img7", "random_img8"]
      var size = images.length;
      var x = Math.floor(size * Math.random());
      if (x < images.length) {
        $('.quizzort_optional_popup').addClass('act_clr_optional_popup' + x);
      }
    },
    QuizCategoryPopupClose() {
      $(".quizzort_main_wrp").removeClass("popup_active");
      setTimeout(() => {
        bus.$emit('hideQuizzorOptional', false);
        bus.$emit('hideQuizzortPopupEnabled', false);
        $("body").removeClass("quizzort_popup_active");
      }, 500)
    },
    QuizzortQuizSHow() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('hideQuizzorOptional', false);
      }, 500);
      bus.$emit('hideQuizCategory', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    },
    QuizzortGamesSHow() {
      $('.quizzort_popup_wrp').removeClass('popup_slide_active')
      setTimeout(() => {
        bus.$emit('hideQuizzorOptional', false);
      }, 500);
      bus.$emit('showQuizzortGames', true);
      setTimeout(() => {
        $('.quizzort_popup_wrp').addClass('popup_slide_active')
      }, 500);
    }
  }
}